import { LanguageCode, languageValidation, surveyQuestionObjectValidation, SurveyQuestionObjectValidationResult, SurveyTheme } from "../..";
import { surveyValidation } from "../fieldValidation/fields/surveyFieldValidation";

export type SurveyThemeObjectValidationResult =
      'invalid_theme'
    | 'invalid_theme_name'
    | 'invalid_translations'
    | SurveyQuestionObjectValidationResult;

function validateTheme(value:SurveyTheme, requiredTranslations:LanguageCode[]): SurveyThemeObjectValidationResult {
    if(value === null || value === undefined || typeof value !== 'object')
        return 'invalid_theme';

    if(!surveyValidation.surveyTheme.name(value.name))
        return 'invalid_theme_name';

    if(!languageValidation.identicalLanguageCodes(requiredTranslations, value.translations.map(t => t.languageCode)))
        return 'invalid_translations';

    if(value.translations.some(t => !surveyValidation.surveyTheme.name(t.text)))
        return 'invalid_translations';

    return surveyQuestionObjectValidation.questionList(value.questions, requiredTranslations);
}

function validateThemeList(value: unknown, requiredTranslations:LanguageCode[]): SurveyThemeObjectValidationResult {
    if(value === null || value === undefined || !Array.isArray(value))
        return 'invalid_theme';

    for(let i=0; i<value.length; i++)
    {
        const validation = validateTheme(value[i], requiredTranslations);
        if(validation !== 'valid')
            return validation;
    }
    return 'valid';
}

export const surveyThemeObjectValidation = {
    validateTheme,
    validateThemeList
};
